// btw-front/src/lib/elapsedDays.js
// 경과일 계산 — 브라우저 로컬(한국 사용자 = KST) 달력 기준. 날짜·일시 표시는 lib/format.js

// 경과일 — 로컬 달력 날짜 차이(시각 무시). [관리 대상 딜] 의 DATEDIFF(NOW(), updated_at) 와 같은 기준.
// 오늘 수정 = 0. 해석 불가면 null, 미래 시각(시계 차이)은 0 으로 본다
export function elapsedDays(value, now = new Date()) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const startOf = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate());
  // 일광절약시간 등으로 하루가 24시간이 아닐 수 있어 반올림
  const days = Math.round((startOf(now) - startOf(d)) / 86400000);
  return Math.max(0, days);
}
